angular.module('bbl.directives.ng-return', [])
.directive('ngReturn', function () {
  return function (scope, element, attrs) {
    element.bind("keydown keypress", function (event) {
      if(event.which === 13) {
        scope.$apply(function (){
          scope.$eval(attrs.ngReturn);
        });

        event.preventDefault();
      }
    });
  };
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/ng-return.js
 ** module id = 173
 ** module chunks = 0
 **/